import { useQuery } from "@tanstack/react-query";
import { COMPANY_MANAGEMENT_SERVICE, restApiRequest } from "src/utils/Api";
import { mockData } from "src/utils/hooks/pointsBank/useCompanyPointsBanks";
import sortByField from "src/utils/jsHelpers/sortByField";

const useCompanyPointsBanks = (
  companyId: string,
  enabled: boolean,
  asOptions: boolean
) =>
  useQuery({
    enabled,
    queryKey: [
      "company-management-points-banks",
      { pointsBankOwnerId: companyId, itemsPerPage: 10000 },
    ],
    queryFn: () =>
      restApiRequest(
        COMPANY_MANAGEMENT_SERVICE,
        `/points-banks/owner?itemsPerPage=10000&pointsBankOwnerId=${companyId}`,
        "GET",
        {},
        mockData
      ),
    select: (
      data: {
        pointsBankId: string;
        name: string;
        fullName: string;
      }[]
    ) =>
      asOptions
        ? sortByField(
            data?.map(({ pointsBankId, name, fullName }) => ({
              value: pointsBankId,
              label: fullName || name,
            })) || [],
            "label"
          )
        : data,
  });

export default useCompanyPointsBanks;
